<template>
    <div class="app-container">
      <div class="top-btn">
        <!-- <vxe-button status="primary">驳回</vxe-button> -->
        <vxe-button status="success" @click="returnToLevel">返回</vxe-button>
      </div>
      <table
      :loading="listLoading">
        <!-- 第一行 -->
        <tr>
          <th>申请单位</th>
          <td>{{form.org_id}}</td>
          <td colspan="3">申请时间：{{ form.cdate }}</td>
        </tr>
  
        <!-- 第二行 -->
        <tr>
          <th>活动类型</th>
          <td class="align-right">
            类型：
          </td>
          <td colspan="3">{{ form.hd_type }}</td>
        </tr>
  
        <!-- 第三行 -->
        <tr>
          <th rowspan="3">活动时间、地点</th>
          <td class="align-right">
            <span>时间：</span>
          </td>
          <td colspan="3">{{ form.hd_begin_time }} <span style="color:red">至</span> {{ form.hd_end_time }}</td>
        </tr>
        <tr>
            <td class="align-right">
                地点：
            </td>
            <td colspan="3">{{ form.hd_address}}</td>
        </tr>
        <tr>
            <td class="align-right">
                详细地址：
            </td>
            <td colspan="3">{{ form.dtl_address}}</td>
        </tr>
  
        <!-- 第四行 -->
        <tr>
          <th rowspan="2">二网活动</th>
          <td class="align-right">是否二网活动：</td>
          <td colspan="3">{{ form.online_stores }}</td>
        </tr>
        <tr>
            <td class="align-right">二网名称：</td>
            <td colspan="3">{{ form.ewd_address }}</td>
        </tr>
        <tr>
            <th>窝子户</th>
            <td class="align-right">客户窝子：</td>
            <td colspan="3">{{ form.household_name }}</td>
        </tr>
        <!-- 第五行 -->
        <tr>
          <th>用户数量</th>
          <td class="align-right">用户数量：</td>
          <td colspan="3">
            <div class="flex-row">
              <span>{{ form.user_number }}</span>
              <button>参加人员名单</button>
            </div>
          </td>
        </tr>
  
        <!-- 第六行 -->
        <tr>
          <th  rowspan="2">活动负责人</th>
          <td class="align-right">活动负责人：</td>
          <td colspan="3">{{ form.hd_head }}</td>
        </tr>
        <tr>
            <td class="align-right">活动负责人联系电话：</td>
            <td colspan="3">{{ form.hd_phone }}</td>
        </tr>
        <!-- 第七行 -->
        <tr>
          <th>巡展，定点展示</th>
          <td class="align-right">路线：</td>
          <td colspan="3">
            <div class="flex-row">
              <textarea readonly rows="3" v-model="form.xz_way"></textarea>
            </div>
          </td>
        </tr>
        <tr>
          <th>品系</th>
          <td class="align-right">品系：</td>
          <td colspan="3">{{ form.strain_ss }}</td>
        </tr>
        <tr>
          <th>参展车辆</th>
          <td class="align-right">车辆型号及数量：</td>
          <td colspan="3">
            <div class="car-box" v-for="(item,index) in vehicleModelList" :key="index">
              <span>车型代码：</span>
              <input v-model="item.configname" disabled/>
              <span style="padding-left:10px">数量：</span>
              <input v-model="item.amount" disabled/>
            </div>
          </td>
        </tr>
        <tr>
          <th rowspan="10">费用预算</th>
          <td class="align-right">会务费：</td>
          <td colspan="3">{{ form.hwf }}</td>
        </tr>
        <tr>
          <td class="align-right">布展费：</td>
          <td colspan="3">{{ form.bzf }}</td>
        </tr>
        <tr>
          <td class="align-right">场地租金：</td>
          <td colspan="3">{{ form.cdzj}}</td>
        </tr>
        <tr>
          <td class="align-right">油费（柴油）：</td>
          <td colspan="3">{{ form.yf}}</td>
        </tr>
        <tr>
          <td class="align-right">过桥过路费：</td>
          <td colspan="3">{{ form.gqglf }}</td>
        </tr>
        <tr>
          <td class="align-right">礼品费：</td>
          <td colspan="3">{{ form.lpf}}</td>
        </tr>
        <tr>
          <td class="align-right">记者劳务费：</td>
          <td colspan="3">{{ form.jzlwf }}</td>
        </tr>
        <tr>
          <td class="align-right">车辆保险：</td>
          <td colspan="3">{{ form.clbx }}</td>
        </tr>
        <tr>
          <td class="align-right">其他费用：</td>
          <td colspan="3">{{ form.qtfy }}</td>
        </tr>
        <tr>
          <td class="align-right">合计：</td>
          <td colspan="3">{{ form.hjfy }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td class="align-right">备注：</td>
          <td colspan="3">
            <div class="flex-row">
              <textarea readonly rows="3" v-model="form.remark"></textarea>
            </div>
          </td>
        </tr>
        <tr>
          <th rowspan="3">附件</th>
          <td class="align-right">活动方案：</td>
          <td colspan="3"><a :href="form.hdfa">{{ form.hdfa }}</a></td>
        </tr>
        <tr>
          <td class="align-right">预计拜访客户名单：</td>
          <td colspan="3"><a :href="form.yjbfyh">{{ form.yjbfyh }}</a></td>
        </tr>
        <tr>
          <td class="align-right">其他附件：</td>
          <td colspan="3"><a :href="form.qtfj">{{ form.qtfj }}</a></td>
        </tr>
      </table>
      <div style="margin-top:30px">
        <vxe-table  
        :loading="listLoading"
        border
        resizable
        height="300"
        :align="allAlign"
        :data="tableData">
            <vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>
            <vxe-table-column field="user_name" width="200" title="审核人"></vxe-table-column>
            <vxe-table-column field="audit_time"  width="200" title="审核日期"></vxe-table-column>
            <vxe-table-column field="audit_idear" title="意见"></vxe-table-column>
            <vxe-table-column field="status_name"  width="100" title="状态"></vxe-table-column>
        </vxe-table>
        <div class="note">
          注：标有 * 的标识为必填项
        </div>
    </div>
    </div>
  </template>
  
  <script>
  import { findByIdTuiGuangDetails } from '@/api/activityCustomer'
  export default {
    name: 'EventDetails',
    data() {
      return {
        listLoading: false,
        form: {
          org_id: '',
          cdate: '',
          hd_type: '',
          hd_begin_time: '',
          hd_end_time: '',
          hd_address: '',
          dtl_address: '',
          online_stores: '',
          ewd_address: '',
          household_name: '',
          user_number: '',
          hd_head: '',
          hd_phone: '',
          xz_way: '',
          strain_ss: '',
          hwf: '',
          bzf: '',
          cdzj: '',
          yf: '',
          gqglf: '',
          lpf: '',
          jzlwf: '',
          clbx: '',
          qtfy: '',
          hjfy: '',
          remark : '',
          hdfa : '',
          yjbfyh : '',
          qtfj : ''
        },
        // 表格数据
        tableData: [],
        vehicleModelList:[],
        allAlign: 'center',
        org_ID:'',
      };
    },
    created() {
      // this.org_ID = '139' 
      this.org_ID = this.$route.query.id
      if (this.$route.query.id) {
        this.queryByPage()
      }
    },
    methods: {
      // 搜索表格数据
      async queryByPage() {
        this.listLoading = true // 开启加载动画
        findByIdTuiGuangDetails(this.org_ID).then(res => {
          if (res.code === 1 && res.data) {
            let data = res.data
            this.form = data.activityApply || this.form
            this.tableData = data.auditList
            this.vehicleModelList = data.vehicleModelList
            this.listLoading = false // 关闭加载动画
          }
        })
      },
      
      // 返回
      returnToLevel() {
        this.$router.push({ path: '/publicizeMaterialManagement/promotionActivitiesList'})
      }
    }
  };
  </script>
  
  <style scoped>
  .top-btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }
  
  th, td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
    white-space: nowrap;
  }
  
  th {
    width: 20%;
    background-color: #f2f2f2;
  }
  
  td {
    background-color: #ffffff;
    white-space: normal;
    word-break: break-all;
  }
  
  .flex-row {
    display: flex;
    align-items: center;
  }
  
  button {
    margin-left: 10px;
  }
  
  textarea {
    width: 100%;
    resize: none;
    border: 1px solid #ccc;
    background-color: #f2f2f2;
    padding: 5px;
  }
  .align-right {
    text-align: right;
  }
  .car-box {
    margin-bottom: 5px;
  }
  .car-box:last-child {
    margin-bottom: 0;
  }
  .vxe-table--header th {
    background-color: #336699;
    color: #ffffff;
  }
  .note {
    margin-top: 10px;
    font-size: 12px;
    color: red;
  }
  
  </style>
  